import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import moment from 'moment';
import { load } from '@/helpers/storage';
const max = (Math.round(moment().unix() / (60 * 15)) * (60 * 15)) * 1000;
const min = max - (7 * 24 * 60 * 60) * 1000;
const defaultTimeRange = () => { return { min: min, max: max }; };
const state = {
    profileIds: load('selected_profiles', []),
    soundSource: load('selected_sound_source', 'inear'),
    widgets: {
        'account': {
            timeRange: load('widgets_account_timeRange', defaultTimeRange)
        },
        'myprofiles': {
            timeRange: load('widgets_myprofiles_timeRange', defaultTimeRange)
        },
        'editDeleteAccount': {
            timeRange: load('widgets_editDeleteAccount_timeRange', defaultTimeRange)
        },
        'profiles': {
            timeRange: load('widgets_profiles_timeRange', defaultTimeRange)
        },
        'support': {
            timeRange: load('widgets_support_timeRange', defaultTimeRange)
        },
        'doseCharts': {
            timeRange: load('widgets_doseCharts_timeRange', defaultTimeRange)
        },
        'map': {
            timeRange: load('widgets_map_timeRange', defaultTimeRange)
        },
        'histogram': {
            timeRange: load('widgets_histogram_timeRange', defaultTimeRange)
        },
        'dbDoughnut': {
            timeRange: load('widgets_dbDoughnut_timeRange', defaultTimeRange)
        },
        'progress': {
            timeRange: load('widgets_progress_timeRange', defaultTimeRange)
        }
    }
};
const module = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
export default module;
